import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Banner from '../../../components/Banner';
import Footer from '../../../components/Footer';
import Sidebar from '../../../components/Sidebar';
import FAVORITES_QUERY from '../../../graphql/MyFavorites';
import ToggleTheaterFavorite from '../../Others/ToggleTheaterFavorite';
import ToggleProductionFavorite from '../../Others/ToggleProductionFavorite';
import ToggleArtistFavorite from '../../Others/ToggleArtistFavorite';


function editActionFormatter(cell, row) {
  const { id, type } = row;
  return (
    <div>
      {type === 'Producción' && (
        <ToggleProductionFavorite id={id} favorite />
      )}
      {type === 'Artista' && (
        <ToggleArtistFavorite id={id} favorite />
      )}
      {type === 'Teatro' && (
        <ToggleTheaterFavorite id={id} favorite />
      )}
    </div>
  );
}

class FavoritesList extends Component {
  onLogout = (e) => {
    this.props.history.push('/login');
  };

  extractFavorites = (obj) => {
    const final = {};

    if (obj.artist) {
      final.id = obj.artist.id;
      final.name = obj.artist.name;
      final.type = 'Artista';
    } else if (obj.theater) {
      final.id = obj.theater.id;
      final.name = obj.theater.name;
      final.type = 'Teatro';
    } else if (obj.production) {
      final.id = obj.production.id;
      final.name = obj.production.name;
      final.type = 'Producción';
    }
    return final;
  };

  render() {
    const favorites =
      this.props.favorites &&
      this.props.favorites.map(v => this.extractFavorites(v));

    return (
      <div>
        <Banner />
        <div className="my-propertiess">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-12">
                <Sidebar active="favorites" onLogout={this.onLogout} />
              </div>

              <div className="col-lg-9 col-md-9 col-sm-12">
                <h1 className="heading">Listado de favoritos</h1>

                <BootstrapTable
                  data={favorites || []}
                  striped
                  hover
                  pagination
                >
                  <TableHeaderColumn isKey dataField="type" dataSort>
                    Tipo
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="name"
                    dataSort
                    filter={{ type: 'TextFilter', delay: 300 }}
                  >
                    Nombre
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="action"
                    dataFormat={editActionFormatter}
                  >
                    Acciones
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withFavorites = graphql(FAVORITES_QUERY, {
  options: () => ({
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data }) => ({
    loading: data.loading,
    favorites: data.myFavorites,
  }),
});

export default withFavorites(FavoritesList);



// WEBPACK FOOTER //
// ./src/containers/Profile/Favorites/index.js